import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { Helmet } from 'react-helmet';
import Wrapper from '../layouts/Wrapper';
import { getDoctorInfo } from '../store/actions/getDoctor';
import Spinner from '../components/Spinner';
import { SITE_URL } from '../utils/schema';

function Doctor() {
  const { id } = useParams();
  const { translations, loading: loadingTranslation } = useSelector((state) => state.translation);
  const lang = Cookies.get('i18next') || 'en';
  const dispatch = useDispatch();
  const { loading, data } = useSelector((state) => state.getDoctor);
  useEffect(() => {
    dispatch(getDoctorInfo({ id }));
  }, [id]);
  // Schema 6: BreadcrumbList — Home > doctor name, matching the visible <h1>.
  const breadcrumbs = data?.full_name?.[lang] ? [{
    name: data.full_name[lang],
    url: `${SITE_URL}/${lang}/doctor/${id}`,
  }] : [];
  return (
    <Wrapper breadcrumbs={breadcrumbs}>
      {(!loading && !loadingTranslation) ? (
        <>
          <Helmet>
            <title>
              {data.full_name && data.full_name[lang]}
            </title>
            {data.canonical_tags && (<link rel="canonical" href={data.canonical_tags[lang]} />)}
          </Helmet>
          <div className="doctor">
            <div className="container medium">
              <div className="doctor-row">
                <div className="doctor-image">
                  <img src={data.image.webp_url} alt={data?.full_name[lang]} />
                  <p className="doctor-name">{data?.full_name[lang]}</p>
                  <div className="doctor-positions">
                    {data.staffSpecializations.map((e) => (
                      <p key={e.id} className="doctor-position">{e.title[lang]}</p>
                    ))}
                  </div>
                </div>
                <div className="doctor-info">
                  <div className="doctor-info-box">
                    <p className="doctor-info-box-title">{translations.education[lang]}</p>
                    <ul className="doctor-info-box-list">
                      <li>
                        <p dangerouslySetInnerHTML={{ __html: data?.education[lang] }} />
                      </li>
                    </ul>
                  </div>
                  <div className="doctor-info-box second">
                    <p className="doctor-info-box-title">{translations.work_experience[lang]}</p>
                    <ul className="doctor-info-box-list">
                      <li>
                        <p dangerouslySetInnerHTML={{ __html: data?.work_experience[lang] }} />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default Doctor;
